export const attendencereportDetails = [
  {
    key:"1",
    Name: "Anthony Lewis",
    Image: "user-32.jpg",
    Role: "Finance",
    Date: "14/01/2024",
    CheckIn: "09:00 AM",
    Status: "Present",
    CheckOut: "06:45 PM",
    Break: "30 Min",
    Late: "32 Min",
    Overtime: "20 Min",
    Progress: 1,
    ProductionHours: "8.55 Hrs",
  },
  {
    key:"2",
    Name: "Brian Villalobos",
    Image: "user-09.jpg",
    Role: "Developer",
    Date: "14/01/2024",
    CheckIn: "09:00 AM",
    Status: "Present",
    CheckOut: "06:12 PM",
    Break: "20 Min",
    Late: "-",
    Overtime: "45 Min",
    Progress: 2,
    ProductionHours: "7.54 Hrs",
  },
  {
    key:"3",
    Name: "Harvey Smith",
    Image: "user-01.jpg",
    Role: "Developer",
    Date: "14/01/2024",
    CheckIn: "09:00 AM",
    Status: "Present",
    CheckOut: "06:13 PM",
    Break: "50 Min",
    Late: "-",
    Overtime: "33 Min",
    Progress: 1,
    ProductionHours: "8.45 Hrs",
  },
  {
    key:"4",
    Name: "Stephan Peralt",
    Image: "user-33.jpg",
    Role: "Executive Officer",
    Date: "14/01/2024",
    CheckIn: "09:00 AM",
    Status: "Present",
    CheckOut: "06:23 PM",
    Break: "41 Min",
    Late: "-",
    Overtime: "50 Min",
    Progress: 1,
    ProductionHours: "8.55 Hrs",
  },
  {
    key:"5",
    Name: "Doglas Martini",
    Image: "user-33.jpg",
    Role: "Manager",
    Date: "14/01/2024",
    CheckIn: "09:00 AM",
    Status: "Present",
    CheckOut: "06:43 PM",
    Break: "23 Min",
    Late: "-",
    Overtime: "10 Min",
    Progress: 1,
    ProductionHours: "8.22 Hrs",
  },
  {
    key:"6",
    Name: "Linda Ray",
    Image: "user-02.jpg",
    Role: "Finance",
    Date: "14/01/2024",
    CheckIn: "09:00 AM",
    Status: "Present",
    CheckOut: "07:15 PM",
    Break: "03 Min",
    Late: "-",
    Overtime: "-",
    Progress: 1,
    ProductionHours: "8.32 Hrs",
  },
  {
    key:"7",
    Name: "Elliot Murray",
    Image: "user-35.jpg",
    Role: "Finance",
    Date: "14/01/2024",
    CheckIn: "09:00 AM",
    Status: "Present",
    CheckOut: "07:13 PM",
    Break: "32 Min",
    Late: "-",
    Overtime: "-",
    Progress: 3,
    ProductionHours: "9.15 Hrs",
  },
  {
    key:"8",
    Name: "Rebecca Smtih",
    Image: "user-36.jpg",
    Role: "Executive",
    Date: "14/01/2024",
    CheckIn: "09:00 AM",
    Status: "Present",
    CheckOut: "09:17 PM",
    Break: "14 Min",
    Late: "12 Min",
    Overtime: "-",
    Progress: 1,
    ProductionHours: "9.25 Hrs",
  },
  {
    key:"9",
    Name: "Connie Waters",
    Image: "user-37.jpg",
    Role: "Developer",
    Date: "14/01/2024",
    CheckIn: "09:00 AM",
    Status: "Present",
    CheckOut: "08:15 PM",
    Break: "12 Min",
    Late: "-",
    Overtime: "-",
    Progress: 1,
    ProductionHours: "8.35Hrs",
  },
  {
    key:"10",
    Name: "Lori Broaddus",
    Image: "user-38.jpg",
    Role: "Developer",
    Date: "14/01/2024",
    CheckIn: "09:00 AM",
    Status: "Absent",
    CheckOut: "09:23 PM",
    Break: "10 Min",
    Late: "-",
    Overtime: "-",
    Progress: 1,
    ProductionHours: "9.15 Hrs",
  },
];
